import FAQSchema from "@components/FAQSchema";
import DetailArticlePageHeader from "@components/common/DetailArticlePageHeader";
import DetailPageLayout from "@components/common/DetailPageLayout";
import { IArticlePageProps } from "@customTypes/commonResponses";
import dynamic from "next/dynamic";
import MainWrapper from "../common/MainWrapper";

const ArticleViewContent = dynamic(() => import("./ArticleViewContent"), {
  ssr: false,
});

const ArticleView = ({
  article,
  topNavigation,
  raqFormType,
  ogImage,
}: IArticlePageProps): JSX.Element => {
  return (
    <MainWrapper>
      <DetailPageLayout>
        <FAQSchema schema={article.FAQ_Schema} />
        <DetailArticlePageHeader title={article.Title} ogImage={ogImage} />
        <ArticleViewContent
          article={article}
          topNavigation={topNavigation}
          raqFormType={raqFormType}
        />
      </DetailPageLayout>
    </MainWrapper>
  );
};

export default ArticleView;
